import styled, { css } from 'styled-components';
import { pageTitleFont } from '../styles/fontStyles';
import { pitchTheme } from '../styles/theme';

/** Shared styles for route-level page titles — extend with size/spacing as needed. */
export const pageTitleStyles = css`
  ${pageTitleFont}
  margin: 0;
  color: ${pitchTheme.text};
`;

const PageTitle = styled.h1`
  ${pageTitleStyles}
`;

export default PageTitle;
